import { inPropertyAudienceTypes } from 'features/Announcements'
import AudienceCard from 'features/Announcements/Sidebar/AudienceCard'

import styles from './Sidebar.module.scss'

const Sidebar = () => {
  return (
    <div className={styles.sidebar}>
      <p className={styles.title}>Guest categories</p>
      <AudienceCard type={inPropertyAudienceTypes.InHouse} />
      <AudienceCard type={inPropertyAudienceTypes.ArrivingToday} />
      <AudienceCard type={inPropertyAudienceTypes.DepartingToday} />
      <AudienceCard type={inPropertyAudienceTypes.DayBeforeCheckOut} />
    </div>
  )
}

export default Sidebar
